import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import OutsideClickHandler from 'react-outside-click-handler';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import cogoToast from 'cogo-toast';
import moment from 'moment';
import cn from 'classnames';

import Loader from '../General/Loader';

import { getUsers } from '../../api/users';

import { isSuperUser, getFullName, isMockingUser } from '../../helpers/user_helpers';
import './Navbar.scss';

class Navbar extends Component {
  static propTypes = {
    mockUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    tab: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.searchDebouncer = AwesomeDebouncePromise(this.fetchResults, 500);
    this.fetchResults();
  }

  fetchResults = () => {
    const { switchUserModalSearchVal } = this.state;
    let queryParams = {};

    if (switchUserModalSearchVal) queryParams.query = switchUserModalSearchVal;

    getUsers(queryParams)
      .then((resp) => {
        this.setState({ switchUserModalUsers: resp });
      })
      .catch((error) => {
        cogoToast.error(`We had an error fetching the users, please try again.`);
      })
      .finally(() => {
        this.setState({ isSearching: false });
      });
  };

  state = {
    // For admins
    isSearching: false,
    showingSwitchUserModal: false,
    switchUserModalSearchVal: '',
    switchUserModalUsers: [],
  };

  getTabs = () => [
    { tabName: 'summary', display: 'Calls', tabHref: '/' },
    ...(window.__ALLOW_DEALS__ ? [{ tabName: 'forecast', display: 'Deals', tabHref: '/deals' }] : []),
    // { tabName: 'insights', display: 'Insights', tabHref: '/insights' },
    ...(window.__ALLOW_UPLOAD__ ? [{ tabName: 'upload', display: 'Upload', tabHref: '/upload' }] : []),
    { tabName: 'account', display: 'Account', tabHref: '/account' },
  ];

  updateSearch = (newVal) => {
    this.setState({ isSearching: true });
    this.setState({ switchUserModalSearchVal: newVal });
    this.searchDebouncer();
  };

  render() {
    const { tab, user, mockUser } = this.props;
    const { showingSwitchUserModal, switchUserModalSearchVal, isSearching, switchUserModalUsers } = this.state;
    const tabs = this.getTabs();
    const canMockUser = isMockingUser(user) || isSuperUser(user);
    return (
      <div className='navbar-outer-container'>
        <div className='navbar-inner-container'>
          <div className='tabs'>
            {tabs.map(({ tabName, icon, display, tabHref }, idx) => (
              <Link to={tabHref || '#'} key={idx} className={cn('tab', { active: tab === tabName })}>
                {display}
              </Link>
            ))}
          </div>
        </div>
        {canMockUser && (
          <div className='account-btns'>
            <div className='label'>
              <div className='main'>
                Logged in as <span className='name'>{getFullName(user)}</span>
                <div className='clear-btn'>{isMockingUser(user) && <div onClick={() => mockUser(null)}>x</div>}</div>
              </div>
              <div className={cn('toggle-btn-container', { 'showing-modal': showingSwitchUserModal })}>
                <div className='switch-user-modal-cover' />
                <div onClick={() => this.setState({ showingSwitchUserModal: true })} className='toggle-btn'>
                  <MoreHoriz />
                </div>
                {showingSwitchUserModal && (
                  <div className='switch-user-modal-outer'>
                    <OutsideClickHandler onOutsideClick={() => this.setState({ showingSwitchUserModal: false })}>
                      <div className='switch-user-modal'>
                        <input
                          autoFocus
                          placeholder='Search Users '
                          value={switchUserModalSearchVal}
                          onChange={(e) => this.updateSearch(e.target.value)}
                        />
                        <div className={cn('switch-user-results', { loading: isSearching })}>
                          {switchUserModalUsers.map((user) => {
                            const { id, company, first_name, last_name, is_company_admin, is_superuser, date_joined } = user;
                            return (
                              <div key={id} className='switch-user-result'>
                                <div className='data'>
                                  <div className='name'>{first_name || last_name ? `${first_name} ${last_name}` : `User ${id}`}</div>
                                  <div className='company'>
                                    {company?.name || 'Unknown Company'}
                                    {is_company_admin ? ` • Admin` : ''}
                                    {is_superuser ? ` • Superuser` : ''}
                                    {` • Joined ${moment(date_joined).format('MMMM Do')} `}
                                  </div>
                                </div>
                                <div onClick={() => mockUser(user)} className='select-btn'>
                                  Select
                                </div>
                              </div>
                            );
                          })}
                          {!switchUserModalUsers.length && isSearching && <Loader size={75} />}
                        </div>
                      </div>
                    </OutsideClickHandler>
                  </div>
                )}
              </div>
            </div>
            <div className='account-btn'></div>
          </div>
        )}
      </div>
    );
  }
}

export default Navbar;
